require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 642
// module chunks = 20